import { FC, ReactNode } from 'react';

import { cn } from '../../../../utils';

interface Props {
    icon: ReactNode;
    label: string;
    count: number;
    isActive: boolean;
    onClick: () => void;
    color?: string;
    bgColor?: string;
    disabled?: boolean;
}

export const StatusFilterButton: FC<Props> = ({
    icon,
    label,
    count,
    isActive,
    onClick,
    color,
    bgColor,
    disabled,
}) => {
    return (
        <button
            className={cn(
                'flex items-center gap-1.5 rounded-xl border px-3 py-1.5 text-xs transition-colors',
                isActive
                    ? 'border-primary/20 bg-primary/10 font-medium text-primary'
                    : 'border-muted bg-transparent text-muted-foreground hover:bg-muted/50',
            )}
            onClick={onClick}
            disabled={disabled}
        >
            <span
                className={cn(
                    'rounded-full p-1',
                    isActive ? bgColor || 'bg-primary/10' : 'bg-muted',
                )}
            >
                <span
                    className={cn(
                        isActive
                            ? color || 'text-primary'
                            : 'text-muted-foreground',
                    )}
                >
                    {icon}
                </span>
            </span>
            <span>{label}</span>
            <span
                className={cn(
                    'rounded-full px-1.5 py-0.5 text-[10px]',
                    isActive
                        ? 'bg-primary/10 text-primary'
                        : 'bg-muted text-muted-foreground',
                )}
            >
                {count}
            </span>
        </button>
    );
};
